<div class="flex flex-col gap-[15px]">
  @if (showSearch) {
    <div @slideDown class="relative">
      <fa-icon [icon]="'magnifying-glass'" class="search-icon-fade absolute left-3 top-1/2 -translate-y-1/2 text-sm"></fa-icon>
      <input
        #searchInput
        type="text"
        [(ngModel)]="searchQuery"
        [placeholder]="'stream-list.search-placeholder' | translate"
        class="pl-9 pr-9"
      />
      <fa-icon
        [icon]="'xmark'"
        class="absolute right-3 top-1/2 -translate-y-1/2 text-sm opacity-30 cursor-pointer hover:opacity-60"
        (click)="toggleSearch()"
      ></fa-icon>
    </div>
  }
  @if (filteredStreams$ | async; as filteredStreams) {
    <div class="flex flex-col gap-3" cdkDropList cdkDropListLockAxis="y" [cdkDropListAutoScrollStep]="7" [cdkDropListDisabled]="!!searchQuery" (cdkDropListDropped)="onDrop($event)">
      @if (filteredStreams.length > 0) {
        @for (stream of filteredStreams; track stream.idflux ?? $index) {
          <div class="stream-drag-item" cdkDrag [cdkDragDisabled]="!!searchQuery" (cdkDragStarted)="onDragStarted()">
            <div class="stream-drag-placeholder rounded" *cdkDragPlaceholder></div>
            <rk-stream-list-item
              [stream]="stream"
              [index]="$index"
              [isFirst]="$first"
              [isLast]="$last"
              [isDragging]="isDragging"
              [dragDisabled]="!!searchQuery"
              [isLastStream]="(currentAppConfigStreamList$ | async)?.length === 1"
              (edit)="onEdit($event)"
              (delete)="onDelete($event)"
              (moveToTop)="onMoveToTop($event)"
              (moveToBottom)="onMoveToBottom($event)"
            ></rk-stream-list-item>
          </div>
        }
      } @else if (searchQuery) {
        <div class="rounded border border-dashed border-black/15 bg-white/70 p-6 text-center">
          <p class="text-base font-semibold">{{ 'stream-list.empty-search-title' | translate }}</p>
          <p class="mt-1 text-sm opacity-60">{{ 'stream-list.empty-search-description' | translate }}</p>
        </div>
      }
    </div>
  }
  <rk-add-new-stream (addStream)="onAdd()"></rk-add-new-stream>
</div>